export const mergeClassNames = (...classes: (string | null | undefined)[]) => classes.filter(x => !!x).join(' ');